import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

async function getSequenceGroup(sequenceGroupID) {
  try {
    return await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.SEQUENCE_ROUTING_TABLE,
      sequenceGroupID,
      false
    );
  } catch (error) {
    console.error(error);
    Exception.catchException(error);
    return null;
  }
}

async function getNextSequenceValue(sequenceName) {
  try {
    return await DBOperationsComb.getNextSequenceValue(sequenceName, false);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

/**
 * Every non-deleted sequence routing, newest first.
 *
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getSequenceRoutings() {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.SEQUENCE_ROUTING_TABLE,
        fetchAll: true,
        sortField: "created_at",
        sortOrder: -1
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return { data: null, totalItems: 0, error: error.message };
  }
}

/**
 * Every sequences_log row (id = the Postgres sequence name, readable_name,
 * description). The table has no is_deleted column, so the default
 * is_deleted filter is turned off.
 *
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getSequenceLogs() {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.SEQUENCES_LOG_TABLE,
        fetchAll: true,
        fetchDeleted: true
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return { data: null, totalItems: 0, error: error.message };
  }
}

/**
 * Creates a Postgres sequence and its sequences_log entry.
 *
 * @returns {Promise<{data: string|null, error: string|null}>} `data` is the
 *   new sequence's name.
 */
async function createSequence(readableName, description = null) {
  try {
    return await DBOperationsComb.createSequence({ readableName, description });
  } catch (error) {
    Exception.catchException(error);
    return { data: null, error: error.message };
  }
}

/**
 * Creates a routing with a single unconditional entry pointing at one
 * sequence. sequence_routing has no created_by / updated_by columns.
 *
 * @returns {Promise<{data: Object|null, id: string|null, error: string|null}>}
 */
async function createSequenceRouting(seqName) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.SEQUENCE_ROUTING_TABLE,
      { sequences: [{ condition: true, seq_name: seqName }] },
      false,
      { attribution: false }
    );
  } catch (error) {
    Exception.catchException(error);
    return { data: null, id: null, error: error.message };
  }
}

export default {
  getSequenceGroup,
  getNextSequenceValue,
  getSequenceRoutings,
  getSequenceLogs,
  createSequence,
  createSequenceRouting
};
